import { LAYOUT_COLUMN__left } from '@/pages/_base/layout_base/LAYOUT_COLUMN__left';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { ENUM__invocation_type, ENUM__invocation_type_utils } from '@shared/dto/generation/graph_invoke/_invocations/_base/ENUM__invocation_type';
import { G_DROPDOWN__generation_tool } from '../../_base/graph_template/G_DROPDOWN__generation_tool';
import { G_DROPDOWN__generation_output_type } from '../../outputs/sidebar/G_DROPDOWN__generation_output_type';
import { G_SIDEBAR__add_node_item } from './G_SIDEBAR__add_node_item';

export function G_SIDEBAR__add_node() {
  /*
   * METHODS
   */

  function get_grouped_types() {
    return new Map<string, ENUM__invocation_type[]>([
      ['SD', ENUM__invocation_type_utils.get_group_sd()],
      ['Image', ENUM__invocation_type_utils.get_group_image()],
      ['Grid2d', ENUM__invocation_type_utils.get_group_grid2d().filter(type => type != ENUM__invocation_type.GRID2D__VIEW)],
      ['Vision', ENUM__invocation_type_utils.get_group_vision()],
      ['Latents', ENUM__invocation_type_utils.get_group_latents()],
      ['Spandrel', ENUM__invocation_type_utils.get_group_spandrel()],
    ]);
  }

  /*
   *
   */

  function render_block(title: string, types: ENUM__invocation_type[]) {
    if (types.is_empty()) return null;

    return (
      <div key={`G_SIDEBAR__add_node_${title}`} className="mb-4">
        <div className="sticky top-0 bg-bar text-xs text-gray-500 font-medium py-2 z-10">{title}</div>
        <div className="flex flex-col gap-y-1">
          {types.map(value => (
            <G_SIDEBAR__add_node_item key={`G_SIDEBAR__add_node_item_${value}`} type={value} />
          ))}
        </div>
      </div>
    );
  }

  /*
   * HTML
   */

  return (
    <LAYOUT_COLUMN__left could_be_hidden>
      <div className="flex flex-col size-full">
        <G_DROPDOWN__generation_output_type />
        <PLACEHOLDER_bar_line className="w-full h-6 border-b border-component-border" />
        <G_DROPDOWN__generation_tool />

        <div className="w-full flex-1 bg-bar px-2 flex flex-col overflow-y-auto">
          <div className="text-xs text-gray-400 font-medium mb-2 px-1 py-2">Add Node</div>

          {Array.from(get_grouped_types().entries()).map(([title, types]) => render_block(title, types))}
        </div>
      </div>
    </LAYOUT_COLUMN__left>
  );
}
